export default __webpack_public_path__ + "static/stevedoring-35cd322c68dec1787e1f123a5deda74f.png";